import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Component, ErrorInfo, ReactNode } from 'react'
import { GAHelper } from '../../helpers/ga.helper';
import { Button } from '@mui/material'

interface Props {
    children?: ReactNode,
    onAccept?: VoidFunction,
}

interface State {
    hasError: boolean,
    onAccept?: VoidFunction,
    error?: Error,
    errorInfo?: ErrorInfo
}

class ErrorBoundary extends Component<Props, State>  {

    constructor(props: any) {
        super(props);
        this.state = {
            hasError: false,
            onAccept: props.onAccept
        };
    }

    static getDerivedStateFromError = () => {
        return { hasError: true };
    };

    componentDidCatch = (error: Error, errorInfo: ErrorInfo) => {
        let stackInfo = (errorInfo?.componentStack || "").substring(0, 100)
        GAHelper.setFrontReject(error.toString(), stackInfo)
        this.setState({ error, errorInfo });
    };

    render() {
        const { hasError } = this.state;
        const { children } = this.props;
        return hasError ? <div className='m-auto' style={{ textAlign: 'center', padding: '1rem 0' }}>
            <h1 className="g-title p-m-auto">
                Ha ocurrido un error
            </h1>
            <h1 className="text-error">
                <FontAwesomeIcon icon={'times'} />
            </h1>
            <p>
                {this.state.error?.toString()}
            </p>
            {this.state.onAccept && <Button onClick={this.state.onAccept} variant='contained'>
                Aceptar
            </Button>}
        </div> : children;
    }

}

export default ErrorBoundary;